import React, { useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import { getErrorMessage } from 'redux/slices/globalError'

const ErrorModal: React.FC = () => {
    const classes = useStyles()
    const message = useSelector(getErrorMessage)

    useEffect(() => {
        window.heap.track('Error Modal Rendered')
    }, [])

    const onRefreshPageHandler = () => window.location.reload()

    const onHomePageHandler = () => {
        window.location.href = `${window.location.protocol}//${window.location.host}`
    }

    return (
        <Container fluid className={classes.container}>
            <h4>Uh oh... This was not on purpose</h4>
            <p className="body-2">{message}</p>

            <Container className="text-center">
                <Button variant="primary" type="submit" className="btn-block" onClick={onRefreshPageHandler}>
                    Refresh page
                </Button>
                <Button variant="secondary" type="submit" className="btn-block" onClick={onHomePageHandler}>
                    Take me home
                </Button>
            </Container>
        </Container>
    )
}

export default ErrorModal
